module.exports = __webpack_public_path__ + "img/ba3.png";